var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPruningShears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 2.8L16.151 4.86798C16.6598 5.54635 16.6854 6.47183 16.2151 7.17738L14.5781 9.63283C14.0998 9.11219 13.4659 8.73683 12.75 8.58054V2H13C13.6295 2 14.2223 2.29639 14.6 2.8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.58054V2H11C10.3705 2 9.77767 2.29639 9.39996 2.8L7.84898 4.86798C7.3402 5.54635 7.31451 6.47183 7.78488 7.17738L9.42185 9.63283C9.90014 9.11219 10.5341 8.73683 11.25 8.58054Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57256 12.7124L7.46158 14.564C6.5052 16.158 6 17.9819 6 19.8408C6 21.0333 6.96671 22 8.1592 22H9.20162C9.64255 22 10 21.6426 10 21.2016C10 19.2025 10.3951 17.2307 11.1545 15.3972C9.85668 15.0752 8.84482 14.0291 8.57256 12.7124Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8455 15.3972C13.6049 17.2307 14 19.2025 14 21.2016C14 21.6426 14.3574 22 14.7984 22H15.8408C17.0333 22 18 21.0333 18 19.8408C18 17.9819 17.4948 16.158 16.5384 14.564L15.4274 12.7124C15.1552 14.0291 14.1433 15.0752 12.8455 15.3972Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPruningShears);
export default __webpack_public_path__ + "static/media/pruning-shears.3c55f5949a8ab1870901f36c291893cd.svg";
export { ForwardRef as ReactComponent };